<template>
  <!--不管当前用户绑定了哪种账号，只要点击任何一个按钮都调用原生的切换功能-->
  <Block type="accountDialog" class="dialog-container account-dialog">
    <Block
      type="accountDialogContainer"
      :class="ap ? 'ap' : false"
      class="account-dialog-container"
    >
      <Title tagName="h1" type="switchTitle" class="dialog-title">
        {{ languages.switch.toUpperCase() }}
      </Title>
      <div
        class="swtich-ways mt110"
        :class="isFiveColsStyle ? 'third-style' : false"
        style="width: 100%"
      >
        <a
          class="swtich-way j-switch-to-em-btn"
          @click="switchPlatformAccount('em')"
          v-if="em && !hideSomeBindBtn && visibleSwitchEmailAccount"
          v-touchActive
        >
          <div class="way-icon em">
            <i class="way-inner-icon hide em"></i>
            <span class="icon-txt hide"> </span>
          </div>
        </a>
        <a
          class="swtich-way j-switch-to-ph-btn"
          @click="switchPlatformAccount('ph')"
          v-if="ph && !hideSomeBindBtn"
          v-touchActive
        >
          <div class="way-icon ph">
            <i class="way-inner-icon hide ph"></i>
            <span class="icon-txt hide"> </span>
          </div>
        </a>
        <a
          class="swtich-way j-switch-to-ap-btn"
          @click="switchAccount('ap')"
          v-if="ap && !hideSomeBindBtn"
          v-touchActive
        >
          <div class="way-icon ap">
            <i class="way-inner-icon hide ap"></i>
            <span class="icon-txt hide">
              {{ languages.SwitchWithThirdWay.replace('\${type}', 'Apple') }}
            </span>
          </div>
          <!-- <p class="way-name hide">Sign in with Apple</p> -->
        </a>
        <a
          class="swtich-way j-switch-to-fb-btn"
          @click="switchAccount('fb')"
          v-if="fb && !hideSomeBindBtn"
          v-touchActive
        >
          <div class="way-icon fb" :class="showApBtnType ? 'rect0' : false">
            <template v-if="showApBtnType">
              <i class="way-inner-icon hide fb"></i>
              <span class="icon-txt hide">
                {{
                  languages.SwitchWithThirdWay.replace('\${type}', 'Facebook')
                }}
              </span>
            </template>
          </div>
          <p class="way-name hide" v-if="!showApBtnType">Facebook</p>
        </a>
        <a
          class="swtich-way j-switch-to-tw-btn"
          @click="switchAccount('tw')"
          v-if="tw && !hideSomeBindBtn"
          v-touchActive
        >
          <div class="way-icon tw" :class="showApBtnType ? 'rect0' : false">
            <template v-if="showApBtnType">
              <i class="way-inner-icon hide tw"></i>
              <span class="icon-txt hide">
                {{
                  languages.SwitchWithThirdWay.replace('\${type}', 'Twitter')
                }}
              </span>
            </template>
          </div>
          <p class="way-name hide" v-if="!showApBtnType">Twitter</p>
        </a>
        <a
          class="swtich-way j-switch-to-ln-btn"
          @click="switchAccount('ln')"
          v-if="ln"
          v-touchActive
        >
          <div class="way-icon ln" :class="showApBtnType ? 'rect0' : false">
            <template v-if="showApBtnType">
              <i class="way-inner-icon hide ln"></i>
              <span class="icon-txt hide">
                {{ languages.SwitchWithThirdWay.replace('\${type}', 'Line') }}
              </span>
            </template>
          </div>
          <p class="way-name hide" v-if="!showApBtnType">Line</p>
        </a>
        <a
          class="swtich-way j-switch-to-nv-btn"
          @click="switchAccount('nv')"
          v-if="nv"
          v-touchActive
        >
          <div class="way-icon nv" :class="showApBtnType ? 'rect0' : false">
            <template v-if="showApBtnType">
              <i class="way-inner-icon hide nv"></i>
              <span class="icon-txt hide">
                {{ languages.SwitchWithThirdWay.replace('\${type}', 'Naver') }}
              </span>
            </template>
          </div>
          <p class="way-name hide" v-if="!showApBtnType">Naver</p>
        </a>
        <a
          class="swtich-way j-switch-to-gp-btn"
          @click="switchAccount('gp')"
          v-if="gp"
          v-touchActive
        >
          <div class="way-icon gp" :class="googleView ? 'rect0' : false">
            <template v-if="googleView">
              <i class="way-inner-icon hide gp"></i>
              <span class="icon-txt hide">
                {{ languages.SwitchWithThirdWay.replace('\${type}', 'Google') }}
              </span>
            </template>
          </div>
          <p class="way-name hide" v-if="!googleView">Google play</p>
        </a>
        <a
          class="swtich-way j-switch-to-hw-btn"
          @click="switchAccount('hw')"
          v-if="hw"
          v-touchActive
        >
          <div class="way-icon hw"></div>
          <p class="way-name hide">HUAWEI</p>
        </a>
        <a
          class="swtich-way j-switch-to-gc-btn"
          @click="switchAccount('gc')"
          v-if="gc"
          v-touchActive
        >
          <div class="way-icon gc" :class="showApBtnType ? 'rect0' : false">
            <template v-if="showApBtnType">
              <i class="way-inner-icon hide gc"></i>
              <span class="icon-txt hide">
                {{
                  languages.SwitchWithThirdWay.replace(
                    '\${type}',
                    'Game Center'
                  )
                }}
              </span>
            </template>
          </div>
          <p class="way-name hide" v-if="!showApBtnType">Game Center</p>
        </a>
        <a
          class="swtich-way j-switch-to-mg-btn"
          @click="showLoginFollowPage"
          v-if="mg"
          v-touchActive
        >
          <div class="way-icon follow" :class="showApBtnType ? 'rect0' : false">
            <template v-if="showApBtnType">
              <i class="way-inner-icon hide follow"></i>
              <span class="icon-txt hide">
                {{
                  languages.SwitchWithThirdWay.replace('\${type}', '引き継ぎ')
                }}
              </span>
            </template>
          </div>
          <p class="way-name hide" v-if="!showApBtnType">
            {{ languages.account_yj }}
          </p>
        </a>
        <a
          class="swtich-way j-switch-to-vk-btn"
          @click="switchAccount('vk')"
          v-if="vk"
          v-touchActive
        >
          <div class="way-icon vk"></div>
          <p class="way-name hide">VK</p>
        </a>
      </div>
    </Block>
    <Button
      type="closeBtn"
      class="close-btn j-close-switch-account-popup"
      @click="closeDialog"
      v-touchActive
    ></Button>
    <transition name="fade" mode="out-in">
      <div class="loading-mask" v-show="loading">
        <div class="load">
          <em class="loading load1"></em>
          <em class="loading load2"></em>
          <em class="loading load3"></em>
        </div>
      </div>
    </transition>
  </Block>
</template>
<script>
import {
  UPDATE_PLATFORM_ACCOUNT_POPUP_VISIBLE,
  UPDATE_PLATFORM_ACCOUNT_BIND,
  UPDATE_PLATFORM_ACCOUNT_UNBIND,
  UPDATE_PLATFORM_ACCOUNT_TYPE
} from '@store/account.js';

const ANDROID = 'android';
const IOS = 'ios';
export default {
  props: [
    'isAndroid',
    'SWITCH_ACCOUNT',
    'REFRESH_LOGIN_STATUS',
    'SET_ORIGIN_USER_TYPE_ACTION',
    'HIDE_DIALOG',
    'BIND_STATE',
    'globalConfig',
    'isServerEnv',
    'gameId',
    'switchAccountCallback'
  ],
  data() {
    let packageName = this.globalConfig.getHrefParam('packageName');
    let packageVersion = this.globalConfig.getHrefParam('packageVersion');
    let CacheToken = this.globalConfig.getHrefParam('CacheToken');
    return {
      ANDROID: ANDROID,
      IOS: IOS,
      hideSomeBindBtn:
        packageName === 'com.global.kingdom.ios' && CacheToken == 1,
      switchBtnState: true,
      loading: false
    };
  },
  computed: {
    visibleSwitchEmailAccount() {
      return this.$store.state.account.visibleSwitchEmailAccount;
    },
    showApBtnType() {
      return this.ap || this.googleView;
    },
    isIOS() {
      return !this.isAndroid;
    },
    googleView() {
      //末日喧嚣 安卓端展示
      return this.isAndroid && '191' === this.gameId;
    },
    deviceType() {
      let device = this.isAndroid ? ANDROID : IOS;
      return device;
    },
    isFiveColsStyle() {
      return this.$store.state.account.bindSupportArr.length === 5;
    },
    fb() {
      return this.$store.state.account.bindSupportArr.includes('fb');
    },
    gp() {
      return this.$store.state.account.bindSupportArr.includes('gp');
    },
    gc() {
      return this.$store.state.account.bindSupportArr.includes('gc');
    },
    tw() {
      return (
        this.$store.state.account.bindSupportArr.includes('tw') &&
        (this.globalConfig.getHrefParam('h5') === '1' || this.gameId !== '171')
      );
    },
    ln() {
      return this.$store.state.account.bindSupportArr.includes('ln');
    },
    nv() {
      return this.$store.state.account.bindSupportArr.includes('nv');
    },
    hw() {
      return this.$store.state.account.bindSupportArr.includes('hw');
    },
    mg() {
      return (
        !this.hideSomeBindBtn &&
        this.$store.state.account.bindSupportArr.includes('mg')
      );
    },
    vk() {
      return this.$store.state.account.bindSupportArr.includes('vk');
    },
    em() {
      return this.$store.state.account.bindSupportArr.includes('em');
    },
    ph() {
      return this.$store.state.account.bindSupportArr.includes('ph');
    },
    fbBinded() {
      return this.$store.state.account.fb.status === this.BIND_STATE;
    },
    gpBinded() {
      return this.$store.state.account.gp.status === this.BIND_STATE;
    },
    gcBinded() {
      return this.$store.state.account.gc.status === this.BIND_STATE;
    },
    lnBinded() {
      return this.$store.state.account.ln.status === this.BIND_STATE;
    },
    nvBinded() {
      return this.$store.state.account.nv.status === this.BIND_STATE;
    },
    twBinded() {
      return this.$store.state.account.tw.status === this.BIND_STATE;
    },
    mgBinded() {
      return this.$store.state.account.mg.status === this.BIND_STATE;
    },
    vkBinded() {
      return this.$store.state.account.vk.status === this.BIND_STATE;
    },
    emBinded() {
      return this.$store.state.account.em.status === this.BIND_STATE;
    },
    phBinded() {
      return this.$store.state.account.ph.status === this.BIND_STATE;
    },
    bindStr() {
      return this.$store.state.bindStr;
    },
    switchStr() {
      return this.$store.state.switchStr;
    },
    switchTips() {
      return this.$store.state.switchTips;
    },
    languages() {
      return this.$store.state.passport.languages;
    },
    hasMigrateFunction() {
      return this.$store.state.passport.hasMigrateFunction;
    },
    ap() {
      return this.$store.state.account.bindSupportArr.includes('ap');
    }
  },
  methods: {
    closeDialog() {
      this.$store.dispatch(this.HIDE_DIALOG);
    },
    // 平台账号切换
    switchPlatformAccount(sdkTypeName) {
      this.$store.commit(UPDATE_PLATFORM_ACCOUNT_BIND, false); // 切换账号模式
      this.$store.commit(UPDATE_PLATFORM_ACCOUNT_UNBIND, false); // 非解绑
      this.$store.commit(UPDATE_PLATFORM_ACCOUNT_TYPE, sdkTypeName); // 是平台账号邮箱还是手机
      this.$store.commit(UPDATE_PLATFORM_ACCOUNT_POPUP_VISIBLE, true);
    },
    switchAccount(type) {
      if (!this.switchBtnState) {
        return false;
      }
      this.loading = true;
      this.switchBtnState = false;
      // 5秒后强制恢复可点击状态
      setTimeout(() => {
        this.loading = false;
        this.switchBtnState = true;
      }, 5000);
      this.$store
        .dispatch(this.SWITCH_ACCOUNT, { type })
        .then(() => {
          this.loading = false;
          this.switchBtnState = true;
          // 刷新登陆态
          this.$store.dispatch(this.REFRESH_LOGIN_STATUS).catch(err => {
            this.$emit('switchFail', err.message);
          });
          let typeId;
          // 0:平台账号 1:facebook 2:google 3:game center 4:游客 5:推特 6:line 7:naver 8:Sign in with Apple 9: huawei 10:vk
          let typeIdMap = {
            fb: 1,
            gp: 2,
            gc: 3,
            tw: 5,
            ln: 6,
            nv: 7,
            ap: 8,
            hw: 9,
            vk: 10
          };
          typeId = typeIdMap[type] || 0;
          this.$store.dispatch(this.SET_ORIGIN_USER_TYPE_ACTION, { typeId });
          this.switchAccountCallback &&
            typeof this.switchAccountCallback === 'function' &&
            this.switchAccountCallback();
        })
        .catch(err => {
          this.loading = false;
          this.switchBtnState = true;
          this.$emit('switchFail', err.message);
        });
    },
    showLoginFollowPage() {
      this.$router.push('loginFollow');
    }
  }
};
</script>

<style scoped lang="scss">
.loading-mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 999;
}
.load {
  position: fixed;
  left: 50%;
  top: 50%;
  font-size: 30px;
  transform: translateY(-50%) translateX(-50%);

  -webkit-transform: translateY(-50%) translateX(-50%);
  .loading {
    display: inline-block;
    margin: auto 2px;
    border: 2px solid #535353;
    width: 16px;
    height: 50px;
    background: #535353;
    animation: loading 1s infinite;
  }
  .load2 {
    animation-delay: 0.1s;
  }
  .load3 {
    animation-delay: 0.2s;
  }
}
@keyframes loading {
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0.4;
    transform: scale(0.5);
  }
}
</style>
